module.exports = __webpack_public_path__ + "686166fd264abeaed17c070aa5a09667.gif";


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/Special/Avdelare/img/koket_mob_gray.gif
 ** module id = 456
 ** module chunks = 0
 **/